//creat test page

import { React, useState } from 'react';
import { Box, Flex, Input, Button, Text, useColorModeValue } from '@chakra-ui/react';
import Card from "components/card/Card.js";

import { QuickAlert } from "theme/components/alerts";
import { userController } from 'lib/user';
import Formfield from 'views/global/field';
import { useLocalStorage } from 'lib/useLocalStorage';


function UserSettings() {
    const { setAlert, clearAlert, showAlert } = QuickAlert();
    const { userDetail, updateDetail } = userController();
	const { getUser } = userDetail();
    const headerBorderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");

    const [user, setUser] = useLocalStorage('user', getUser);
    const [loading, setLoading] = useState(false);

    const [input, setInput] = useState({
        name: getUser.name,
        password: "",
        password_confirmation: "",
    });

    const handleInput = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleUpdateProfile = () => {
        setLoading(true);
        updateDetail(input).then(response => {
            clearAlert();
            setAlert(response.data.type,response.data.message);
            setUser(response.data.user);
            setLoading(false);
          }).catch(function(error) {
              setAlert("error",error.response.data.errors);
              setLoading(false);
          });
    }

    return (
        <Box>
            <Card mb='20px' p='0'>
                <Flex justify="space-between" align="center" pt="20px" pb="16px" px="24px" borderBottom="1px solid" borderColor={headerBorderColor}>
                    <Text color="secondaryGray.900" fontSize="22px" fontWeight="700" lineHeight="100%">
                        Account
                    </Text>
                </Flex>
                <Box px="24px" pt="20px" pb="24px">
                    {showAlert()}
                    <Formfield label="Nome" required="true">
                        <Input type="text" defaultValue={getUser.name} name="name" onChange={handleInput} />
                    </Formfield>
                    <Formfield label="Email">
                        <Input type="text" value={getUser.email}  disabled />
                    </Formfield>
                    <Formfield label="Password" help="Lascia vuoto per mantenere la password attuale.">
                        <Input type="password" name="password" onChange={handleInput} />
                    </Formfield>
                    <Formfield label="Conferma Password">
                        <Input type="password" name="password_confirmation" onChange={handleInput} />
                    </Formfield>
                </Box>
                <Flex align="center" pt="16px" pb="16px" px="24px" borderTop="1px solid" borderColor={headerBorderColor}>
                    <Button isLoading={loading} variant="brand" minWidth="150px" onClick={handleUpdateProfile}>Aggiorna</Button>
                </Flex>
            </Card>
        </Box>
    );
}
export default UserSettings;
